const UserManagerApiUrl = {
    //#region Users
    LoginUser: 'api/Users/LoginUser',
    GetAllUsers: 'api/Users/GetAllUsers',
    GetUserById: 'api/Users/GetUserById',
    AddUpdateUser: 'api/Users/AddUpdateUser',
    DeleteUserById: 'api/Users/DeleteUserById',
    //#endregion

    //#region Module Role Mapping
    GetModuleRoleMappings: "api/ModuleRoleMapping/GetModuleRoleMappings",
    AddModuleRoleMappings: "api/ModuleRoleMapping/AddModuleRoleMappings",
    UpdateModuleRoleMappings: "api/ModuleRoleMapping/UpdateModuleRoleMappings",
    //#endregion

    //#region User Role Mapping
    GetUserRoleMappings: "api/UserRoleMapping/GetUserRoleMappings",
    AddUserRoleMappings: "api/UserRoleMapping/AddUserRoleMappings",
    UpdateUserRoleMappings: "api/UserRoleMapping/UpdateUserRoleMappings",
    //#endregion

    //#region User company Mapping
    SwitchCompany: "api/Users/SwitchCompany",
    ExchangeCode: "api/Users/ExchangeCode",
    GetLinkUserCompany: "api/Users/GetLinkUserCompany",
    LinkUserCompany: "api/Users/LinkUserCompany",
    UnLinkUserCompany: "api/Users/UnLinkUserCompany",
    //#endregion

}
export default UserManagerApiUrl;